module.exports = __webpack_public_path__ + "media/educators/student-materials@2x-0716ba1f.jpg";